import { NgModule } from '@angular/core';
import { MixedLoyaltyListComponent } from './components/mixed-loyalty-list/mixed-loyalty-list.component';
import { UserModule } from '../user/user.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MixedLoyaltyItemComponent } from './components/mixed-loyalty-item/mixed-loyalty-item.component';
import { MarketplaceListComponent } from './components/marketplace-list/marketplace-list.component';
import { MarketplaceListItemComponent } from './components/marketplace-list-item/marketplace-list-item.component';
import { AuctionPanelComponent } from './components/auction-panel/auction-panel.component';
import { LottosListItemComponent } from './components/lottos-list-item/lottos-list-item.component';
import { LottosListComponent } from './components/lottos-list/lottos-list.component';
import { LottoDetailsComponent } from './components/lotto-details/lotto-details.component';
import { LottosWalletListComponent } from './components/lottos-wallet-list/lottos-wallet-list.component';
import { LottosWalletListItemComponent } from './components/lottos-wallet-list-item/lottos-wallet-list-item.component';
import { LottosWalletDetailsComponent } from './components/lottos-wallet-details/lottos-wallet-details.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CollectAddressModal } from './components/collect-address-modal/collect-address-modal.component';
import { SubscriptionsListComponent } from './components/subscriptions-list/subscriptions-list.component';
import { SubscriptionsListItemComponent } from './components/subscriptions-list-item/subscriptions-list-item.component';
import { SubscriptionsListItemRenewalsComponent } from './components/subscriptions-list-item-renewals/subscriptions-list-item-renewals.component';
import { SubscriptionsListItemSubscribedComponent } from './components/subscriptions-list-item-subscribed/subscriptions-list-item-subscribed.component';
import { CartItemSubscriptionsComponent } from './components/cart-item-subscriptions/cart-item-subscriptions.component';
import { CartSubscriptionsModalComponent } from './components/cart-item-subscriptions/cart-subscriptions-modal/cart-subscriptions-modal.component';

import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [
    MixedLoyaltyItemComponent,
    MixedLoyaltyListComponent,
    MarketplaceListComponent,
    MarketplaceListItemComponent,
    AuctionPanelComponent,
    LottosListItemComponent,
    LottosListComponent,
    LottoDetailsComponent,
    LottosWalletListComponent,
    LottosWalletListItemComponent,
    LottosWalletDetailsComponent,
    CollectAddressModal,
    SubscriptionsListComponent,
    SubscriptionsListItemComponent,
    SubscriptionsListItemRenewalsComponent,
    SubscriptionsListItemSubscribedComponent,
    CartItemSubscriptionsComponent,
    CartSubscriptionsModalComponent,
  ],
  exports: [
    MixedLoyaltyItemComponent,
    MixedLoyaltyListComponent,
    MarketplaceListComponent,
    MarketplaceListItemComponent,
    AuctionPanelComponent,
    LottosListItemComponent,
    LottosListComponent,
    LottoDetailsComponent,
    LottosWalletListComponent,
    LottosWalletListItemComponent,
    LottosWalletDetailsComponent,
    CollectAddressModal,
    SubscriptionsListComponent,
    SubscriptionsListItemComponent,
    SubscriptionsListItemRenewalsComponent,
    SubscriptionsListItemSubscribedComponent,
    CartItemSubscriptionsComponent,
    CartSubscriptionsModalComponent,
    LottosWalletListItemComponent,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselModule,
    NumberInputModule,
    BrowserAnimationsModule,
    SharedModule,
    InlineSVGModule.forRoot(),
    UserModule,
    ErrorsModule,
    ShortLongDescriptionModule,
    FGBSharedModule
  ],
})
export class LoyaltyModule {}
